import { fetchConToken, fetchDocuments } from "../helpers/fetch";
import { downloadDocuments, base64ToBlob } from "../helpers/downloadDocument";
import { types } from "../types/types";
import { startLogout } from "./auth";
import { uiOpenModalPdf, uiSetPdfBlob } from "./uiPdf";
import { spinnerLoaded } from "./spinner";
import Swal from "sweetalert2";

export const deliveryStartLoading = (id) => {

    return async(dispatch) => {

        try {
            const resp = await fetchConToken(`stockmovement/`);
            const body = await resp.json();
            if (resp.status === 200 && body) {
                dispatch(deliveryLoaded(body));
            } else {
                if (body?.token === false) {
                    dispatch(startLogout());
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
}

const deliveryLoaded = (delivery) => ({
    type: types.deliveryLoaded,
    payload: delivery
})

export const filterDeliveryDonwload = (data) => {

    return async(dispatch) => {

        try {
            const resp = await fetchConToken(`deliverynote/downloads`, data);
            const body = await resp.json();
            if (resp.status === 200 && body) {
                dispatch(deliveryLoaded(body));
            } else {
                if (body?.token === false) {
                    dispatch(startLogout());
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
}

const deliveryNumberLoaded = (deliveryN) => ({
    type: types.deliveryNLoaded,
    payload: deliveryN
});

export const resetDeliveryN = () => ({
    type: types.resetDeliveryN
});

export const filterDeliveryDonwloadN = (data) => {

    return async(dispatch,) => {
        dispatch(spinnerLoaded(true));
        try {
            const resp = await fetchConToken(`deliverynote/ndownloads`, data);
            const body = await resp.json();
            if (resp.status === 200 && body) {
                dispatch(deliveryNumberLoaded(body));
                dispatch(spinnerLoaded(false));
            } else {
                dispatch(spinnerLoaded(false));
                if (body?.token === false) {
                    dispatch(startLogout());
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
}

const deliveryExpeditionLoaded = (deliveryE) => ({
    type: types.deliveryExpeditionLoaded,
    payload: deliveryE
});

export const filterDeliveryExpedition= (data) => {

    return async(dispatch) => {

        try {
            const resp = await fetchConToken(`deliverynote/expeditions`, data);
            const body = await resp.json();
            if (resp.status === 200 && body) {
                dispatch(deliveryExpeditionLoaded(body));
            } else {
                if (body?.token === false) {
                    dispatch(startLogout());
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
}

const ordersOrDeliverysListExpLoaded = (orderOrDeliveryE) => ({
    type: types.ordersOrDeliverysListExpLoaded,
    payload: orderOrDeliveryE
});

export const ordersOrDeliverysExpList = (data) => {

    return async(dispatch) => {
        try {
            const resp = await fetchConToken(`deliverynote/expeditions/list`, data);
            const body = await resp.json();
            if (resp.status === 200 && body) {
                dispatch(ordersOrDeliverysListExpLoaded(body));
            } else {
                if (body?.token === false) {
                    dispatch(startLogout());
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const downloadDeliveryNote = (data) => {
    return async(dispatch) => {
        const resp = await fetchDocuments(`deliverynote/pdf`, data, () => dispatch(startLogout()));
        await downloadDocuments(resp);
    }
}

export const downloadMultipleDeliveryNotes = (deliverys) => {
    return async(dispatch, getState) => {
        try {
            const total = deliverys.data.length;
            dispatch({type: types.downloadStart});
            dispatch({type: types.downloadSetTotal, payload: total});
            for (let i=0; i < total; i++) {
                if (getState().download.canceled) break;
                const item = deliverys.data[i];
                const data = {
                    store: undefined,
                    deliverynote: item.deliverynote,
                    providercode: item.providercode,
                }
                await dispatch(downloadDeliveryNote(data));
                const progress = Math.round(((i + 1) / total) * 100);
                dispatch({type: types.downloadProgress, payload: progress});
            }
            dispatch({type: types.downloadFinish});
        } catch (error) {
            console.log(error);
            dispatch({type: types.downloadCloseModal});
        }
    }
}

export const loadDeliveryNoteBlob = (data) => {
    return async(dispatch) => {
        const resp = await fetchDocuments(`deliverynote/pdf`, data, () => dispatch(startLogout()));
        if (!Array.isArray(resp?.documents) || resp.documents.length === 0 ) {
            const msg = 'No hay archivo disponible para previsualizar.';
            Swal.fire('Descarga', msg, 'info');
            return;
        }

        const doc = resp.documents[0];
        if (!doc?.base64 || !doc?.format || !doc?.filename) {
            Swal.fire('Descarga', 'El documento recibido no tiene un formato valido.', 'error');
            return;
        }

        const blob = base64ToBlob(doc.base64, `application/${doc.format}`);

        dispatch(uiSetPdfBlob(blob, doc.filename));
        dispatch(uiOpenModalPdf());
    }
}
